export const cities = [
  // Largest cities
  'Москва',
  'Санкт-Петербург',
  'Киев',
  'Минск',
  'Алматы',
  'Ташкент',
  'Харьков',
  'Одесса',
  'Днепр',
  'Новосибирск',
  'Екатеринбург',
  'Нижний Новгород',
  'Самара',
  'Казань',
  'Челябинск',
  'Омск',
  'Ростов-на-Дону',
  'Уфа',
  'Красноярск',
  'Пермь',
  'Воронеж',
  'Волгоград',

  // Remaining cities sorted alphabetically
  'Абакан',
  'Актобе',
  'Алмалык',
  'Алчевск',
  'Альметьевск',
  'Анапа',
  'Ангрен',
  'Андижан',
  'Астана',
  'Астрахань',
  'Атырау',
  'Балаково',
  'Барановичи',
  'Барнаул',
  'Бекабад',
  'Белая Церковь',
  'Белгород',
  'Бердянск',
  'Березники',
  'Бийск',
  'Бобруйск',
  'Борисов',
  'Братск',
  'Брест',
  'Бровары',
  'Брянск',
  'Бухара',
  'Великий Новгород',
  'Витебск',
  'Владикавказ',
  'Владимир',
  'Владивосток',
  'Вологда',
  'Гомель',
  'Горловка',
  'Гродно',
  'Джиззак',
  'Дзержинск',
  'Донецк',
  'Евпатория',
  'Житомир',
  'Запорожье',
  'Ивано-Франковск',
  'Иваново',
  'Ижевск',
  'Иркутск',
  'Йошкар-Ола',
  'Калининград',
  'Калуга',
  'Каменское',
  'Камышин',
  'Караганда',
  'Карши',
  'Каспийск',
  'Керчь',
  'Киров',
  'Кисловодск',
  'Коканд',
  'Кокшетау',
  'Коломна',
  'Кострома',
  'Костанай',
  'Краматорск',
  'Красногорск',
  'Краснодар',
  'Кривой Рог',
  'Кропивницкий',
  'Курган',
  'Курск',
  'Кызылорда',
  'Лида',
  'Липецк',
  'Луганск',
  'Луцк',
  'Люберцы',
  'Львов',
  'Магнитогорск',
  'Макеевка',
  'Мариуполь',
  'Маргилан',
  'Махачкала',
  'Мелитополь',
  'Миасс',
  'Мозырь',
  'Могилёв',
  'Мурманск',
  'Муром',
  'Нальчик',
  'Наманган',
  'Назрань',
  'Навои',
  'Невинномысск',
  'Николаев',
  'Никополь',
  'Нижний Тагил',
  'Новый Уренгой',
  'Норильск',
  'Ноябрьск',
  'Нукус',
  'Обнинск',
  'Одинцово',
  'Орёл',
  'Оренбург',
  'Орехово-Зуево',
  'Орша',
  'Павлодар',
  'Павлоград',
  'Пенза',
  'Первоуральск',
  'Петропавловск',
  'Пинск',
  'Подольск',
  'Полтава',
  'Прокопьевск',
  'Псков',
  'Пятигорск',
  'Ровно',
  'Рудный',
  'Рыбинск',
  'Рязань',
  'Салават',
  'Салехард',
  'Самарканд',
  'Саранск',
  'Саратов',
  'Севастополь',
  'Северодвинск',
  'Северодонецк',
  'Симферополь',
  'Славянск',
  'Смоленск',
  'Сочи',
  'Ставрополь',
  'Стерлитамак',
  'Сумы',
  'Сургут',
  'Сызрань',
  'Сыктывкар',
  'Тамбов',
  'Тараз',
  'Ташкент',
  'Тверь',
  'Тернополь',
  'Термез',
  'Тобольск',
  'Тольятти',
  'Томск',
  'Тула',
  'Туркестан',
  'Тюмень',
  'Улан-Удэ',
  'Ульяновск',
  'Умань',
  'Уральск',
  'Ургенч',
  'Уссурийск',
  'Усть-Каменогорск',
  'Уфа',
  'Хабаровск',
  'Херсон',
  'Химки',
  'Хмельницкий',
  'Чебоксары',
  'Черкассы',
  'Чернигов',
  'Черновцы',
  'Черкесск',
  'Чита',
  'Шахты',
  'Шахрисабз',
  'Шымкент',
  'Экибастуз',
  'Электросталь',
  'Элиста',
  'Южно-Сахалинск',
  'Якутск',
  'Актау',
  'Армавир',
  'Архангельск',
  'Балашиха',
  'Биробиджан',
  'Благовещенск',
  'Винница',
  'Волжский',
  'Грозный',
  'Дубна',
  'Жуковский',
  'Звенигород',
  'Каменск-Уральский',
  'Кемерово',
  'Комсомольск-на-Амуре',
  'Королёв',
  'Кременчуг',
  'Кронштадт',
  'Майкоп',
  'Набережные Челны',
  'Находка',
  'Новокузнецк',
  'Новомосковск',
  'Новороссийск',
  'Орел',
  'Орск',
  'Петрозаводск',
  'Петропавловск-Камчатский',
  'Светлогорск',
  'Семей',
  'Серпухов',
  'Старый Оскол',
  'Таганрог',
  'Талдыкорган',
  'Темиртау',
  'Ужгород',
  'Фергана',
  'Череповец',
  'Чирчик',
  'Ярославль',
];
